import React from 'react';
import Kyc from './Kyc';

// Tabs for KYC Verification: Business Verification, Personal KYC, Operational Address
const verificationTabs = ['business', 'personal', 'address'];

const KycVerification = () => {
  return <Kyc filterTabs={verificationTabs} isKYC={true} />;
};

export default KycVerification;
